import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, ListGroup, ListGroupItem } from 'reactstrap';

const SettingsMenu = ({ toggleMenuTab, activeTab }) => {
  const { t } = useTranslation();

  const ListItem = ({ activeTab, tabName, title, onClick }) => (
    <ListGroupItem
      action
      style={{ cursor: 'pointer' }}
      className={activeTab === tabName ? 'active' : ''}
      onClick={onClick}
    >
      {title}
    </ListGroupItem>
  );

  return (
    <>
      {/* USER SETTINGS */}
      <Card className="card-default mb-1">
        <div className="card-header bg-gray-lighter text-bold">{t('settings.USER_SETTINGS')}</div>
        <ListGroup>
          <ListItem
            activeTab={activeTab}
            tabName="profile"
            title={t('settings.PROFILE')}
            onClick={() => toggleMenuTab('profile')}
          />
          <ListItem
            activeTab={activeTab}
            tabName="account"
            title={t('common.CHANGE_PASSWORD')}
            onClick={() => toggleMenuTab('account')}
          />
          <ListItem
            activeTab={activeTab}
            tabName="notifications"
            title={t('settings.NOTIFICATIONS')}
            onClick={() => toggleMenuTab('notifications')}
          />
        </ListGroup>
      </Card>

      {/* COMPANY SETTINGS */}
      <Card className="card-default mb-1">
        <div className="card-header bg-gray-lighter text-bold">{t('settings.COMPANY_SETTINGS')}</div>
        <ListGroup>
          <ListItem
            activeTab={activeTab}
            tabName="companyProfile"
            title={t('settings.PROFILE')}
            onClick={() => toggleMenuTab('companyProfile')}
          />
          <ListItem
            activeTab={activeTab}
            tabName="companyUsers"
            title={t('settings.USERS_RECRUITERS')}
            onClick={() => toggleMenuTab('companyUsers')}
          />
          {/* <ListItem
            activeTab={activeTab}
            tabName="paymentOptions"
            title={t('settings.PAYMENT_OPTIONS')}
            onClick={() => toggleMenuTab('paymentOptions')}
          />
          <ListItem
            activeTab={activeTab}
            tabName="companyAutomatedEmails"
            title={t('settings.COMPANY_AUTOMATED_EMAILS')}
            onClick={() => toggleMenuTab('companyAutomatedEmails')}
          /> */}
        </ListGroup>
      </Card>
    </>
  );
};

export default SettingsMenu;
